import { GrowthBookProvider as GBProvider, GrowthBook } from "@growthbook/growthbook-react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export const growthbookInstance = new GrowthBook({
	apiHost: import.meta.env.VITE_GROWTHBOOK_URL,
	clientKey: import.meta.env.VITE_GROWTHBOOK_KEY,
	enableDevMode: import.meta.env.DEV,
});

const GrowthBookProvider = ({ children }) => {
	const { business_units: businessUnits, id } = useSelector((state) => state.auth.user);
	const vesselData = useSelector((state) => state.modules.vessels?.vesselDetails);

	useEffect(() => {
		void growthbookInstance.init({ streaming: true }).then(() => {
			void growthbookInstance.setAttributes({
				businessUnitsNames: businessUnits?.map((unit) => unit.name),
				userId: String(id),
				vessel: vesselData, // whole object: business_unit, client, modules, etc.
				company_id: String(vesselData?.client.company_id),
			});
		});
	}, [businessUnits, id, vesselData]);

	return <GBProvider growthbook={growthbookInstance}>{children}</GBProvider>;
};

export default GrowthBookProvider;
